import axios, { isAxiosError } from "axios"
import { useEffect, useState } from "react"
import Pagination from "../../component/Pagination"
import Popup from "../../component/Popup"
import ImageTagsDetails from "../SocialTrendsTags/ImageTagsDetails"

const LIMIT = 100
const HotPairImages = ({ show, hidePopup, trend, searchParams }) => {

  const [sort, setSort] = useState('time')
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [images, setImages] = useState([])


  const getProducts = async (signal) => {
    setLoading(true)
    try {

      const response = await axios.get(`/api/hot-pairs/images`, {
        params: {
          s1tag: trend.set1Tag,
          s1value: trend.set1Value,
          s1category: trend.set1Category,
          s2tag: trend.set2Tag,
          s2value: trend.set2Value,
          s2category: trend.set2Category,
          sort,
          page,
          gender: searchParams.get('gender'),
          geography: searchParams.get('geography'),
          limit: LIMIT
        }, signal
      })
      if (response.data && response.data.images) {
        setImages(response.data.images)
        setTotal(response.data.count)
        setLoading(false)

      }
    } catch (e) {
      if (!isAxiosError(e)) {
        console.error(e)
      }
    }
  }

  useEffect(() => {
    const abortController = new AbortController()
    getProducts(abortController.signal)
    return () => { abortController.abort(); }
  }, [trend, searchParams, sort, page])

  useEffect(() => {
    setTotalPages(Math.ceil(total / LIMIT))

  }, [total])


  return show ? <Popup isPopUp={show} setIsPopUp={hidePopup}>
    <div className="w-[80vw] h-[80vh]">
      <div>
        <h2 className="text-center font-semibold text-2xl"> Images</h2>
        <div className="flex w-full justify-between border-b pb-1">
          <div className="flex">
            <select className="p-1 rounded m-1" value={sort} onChange={e => {
              setSort(e.target.value)
              setPage(1)
            }}>
              <option value={'select'} disabled>--select sort--</option>
              <option value={'time'} >Timestamp</option>
              <option value={'forecast'} >Forecast</option>
            </select>
          </div>
          <Pagination page={page} count={totalPages} onChange={setPage} />


        </div>

        <div className="flex flex-wrap w-full">
          {images.map(image => <div className="w-1/6 shrink-0 border">
            <img src={image.imageUrl} className='h-60 ' />
            <div className="px-3 text-xs">
              <a href={`${image.postUrl}`} className='text-blue-600 font-medium' target='_blank'>{image.username}</a>
              <p>{new Date(image.timeStamp).toDateString()}</p>
              <ImageTagsDetails mediaId={image.mediaId} />
            </div>
          </div>)}
        </div>


        <div className="flex w-full justify-between pb-1">
          <div className="flex">
            <select className="p-1 rounded m-1">
              <option value={'select'} disabled>--select sort--</option>
              <option value={'time'} >Timestamp</option>
              <option value={'forecast'} >Forecast</option>
            </select>
          </div>
          <Pagination page={page} count={totalPages} onChange={setPage} />


        </div>
      </div>

    </div>

  </Popup> : null

}

export default HotPairImages
